/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'

import Header from './header'
import Footer from './footer'

const Layout = ({ cover, className, children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  let mainClass = 'my-8'

  if (className) {
    mainClass += ` ${className}`
  }

  return (
    <div className="min-h-screen relative">
      <div className="pb-48">
        <Header siteTitle={data.site.siteMetadata.title} />
        <div className="w-full h-auto">{cover}</div>
        <div className="container">
          <main className={mainClass}>{children}</main>
        </div>
      </div>
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  cover: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default Layout
